import ReviewCriteria from './ReviewCriteria';

export default class ExclusionCount {
  constructor(data = {}) {
    this.exclusionCriteria = new ReviewCriteria(
      data.exclusionCriteria
    );
    this.count = data.count;
  }
}
